export default "__VITE_ASSET__BO$c3VU$__"